import { useSelector } from 'react-redux'

import { selectUserData } from '../routing/fetchingfunction/user/user.reducer'

import { dateFormats } from '../constants'

const useDateFormat = () => {
  const userData = useSelector(selectUserData)

  return userData?.profile?.date_format || dateFormats[0].value
}

export default useDateFormat
